<template>
  <sub-page :title="title">
    <div class="salary-page">
      <div class="section-card">
        <div class="section-title">行业领域</div>
        <div class="radio-group">
          <div class="radio-item" @click="selected = 0">
            <div class="radio-circle" :class="{ checked: selected === 0 }">
              <svg v-if="selected === 0" viewBox="0 0 24 24" class="check-icon"><path d="M20 6 L9 17 L4 12" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <span class="radio-text">工程建设领域拖欠工资线索反映</span>
          </div>
          <div class="radio-item" @click="selected = 1">
            <div class="radio-circle" :class="{ checked: selected === 1 }">
              <svg v-if="selected === 1" viewBox="0 0 24 24" class="check-icon"><path d="M20 6 L9 17 L4 12" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <span class="radio-text">非工程建设领域拖欠工资线索反映</span>
          </div>
        </div>
        <div class="desc-text">
          填写说明：请根据反映问题所属领域选择相应通道，反映有关线索，带"*"的为必填项，其他为选填项。非同一单位欠薪，请分别填写线索。
        </div>
        <div class="agreement" @click="agreed = !agreed">
          <div class="checkbox" :class="{ checked: agreed }">
            <svg v-if="agreed" viewBox="0 0 24 24" class="check-icon"><path d="M20 6 L9 17 L4 12" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
          <span class="agreement-text">同意使用须知：本平台旨在接收拖欠工资问题线索，请您按照平台提示要求如实、完整地填写相关信息并积极配合调查，属地相关部门将依法依规及时处理。</span>
        </div>
      </div>
      <div class="btn-area">
        <button class="next-btn" @click="handleNext">下一步</button>
      </div>
      <div class="bottom-btn">
        <button class="submit-btn" @click="handleSubmit">提交</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'Salary',
  components: { SubPage },
  data() {
    return {
      title: '欠薪线索反映',
      selected: 0,
      agreed: false
    }
  },
  methods: {
    handleNext() {
      // 下一步逻辑
    },
    handleSubmit() {
      // 提交逻辑
    }
  }
}
</script>

<style scoped>
.salary-page {
  background: #F3F8FB;
  min-height: 100%;
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.section-card {
  background: #fff;
  border-radius: calc(8 * var(--w));
  padding: calc(32 * var(--w));
}
.section-title {
  font-size: calc(44 * var(--w));
  font-weight: 500;
  color: #323233;
  margin-bottom: calc(32 * var(--w));
}
.radio-group {
  display: flex;
  flex-direction: column;
  gap: calc(24 * var(--w));
}
.radio-item {
  display: flex;
  align-items: center;
  gap: calc(16 * var(--w));
  cursor: pointer;
}
.radio-circle {
  width: calc(40 * var(--w));
  height: calc(40 * var(--w));
  border-radius: 50%;
  border: 2px solid #dcdee0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.radio-circle.checked {
  background: #2E8CF6;
  border-color: #2E8CF6;
}
.check-icon {
  width: calc(24 * var(--w));
  height: calc(24 * var(--w));
}
.radio-text {
  font-size: calc(36 * var(--w));
  color: #323233;
}
.desc-text {
  margin-top: calc(32 * var(--w));
  font-size: calc(30 * var(--w));
  color: #969799;
  line-height: 1.6;
}
.agreement {
  display: flex;
  align-items: flex-start;
  gap: calc(16 * var(--w));
  margin-top: calc(32 * var(--w));
  cursor: pointer;
}
.checkbox {
  width: calc(36 * var(--w));
  height: calc(36 * var(--w));
  border-radius: calc(4 * var(--w));
  border: 2px solid #dcdee0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: calc(2 * var(--w));
}
.checkbox.checked {
  background: #2E8CF6;
  border-color: #2E8CF6;
}
.agreement-text {
  font-size: calc(30 * var(--w));
  color: #323233;
  line-height: 1.6;
}
.btn-area {
  margin-top: calc(48 * var(--w));
}
.next-btn {
  width: 100%;
  height: calc(88 * var(--w));
  background: #C0C4CC;
  color: #fff;
  font-size: calc(40 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
.bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: calc(16 * var(--w)) calc(32 * var(--w));
  background: #F3F8FB;
}
.submit-btn {
  width: 100%;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(40 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Salary.vue